import React, { useState } from "react";
import { Link } from "react-router-dom";
import CardAuctionsForOpen from "../../../components/cards/auction/CardAuctionsForOpen";
import CardAuctionsForClosed from "../../../components/cards/auction/CardAuctionsForClosed";
import AuctionsProfileOpen from "../../../components/cards/auction/AuctionsProfileOpen";
import AuctionsProfileClose from "../../../components/cards/auction/AuctionsProfileClose";

const ProfileAuction = () => {
    const [checkLoader, setCheckLoader] = useState(false);
    const [selectedTab, setSelectedTab] = useState("open"); // Default tab is "open"

    // Function to handle tab changes
    const handleTabChange = (tab) => {
        setSelectedTab(tab);
    };

    return (
        <>
            <div className="d-flex justify-content-between">
                <div className="d-flex space-x-10 mb-30 nav-tabs">
                    <button
                        className={`btn btn-sm ${selectedTab === "open" ? "active btn-primary" : "btn-white"}`}
                        onClick={() => handleTabChange("open")}
                    >
                        Open
                    </button>
                    <button
                        className={`btn  btn-sm ${selectedTab === "closed" ? "active btn-primary" : "btn-white"}`}
                        onClick={() => handleTabChange("closed")}
                    >
                        Closed
                    </button>
                </div>
            </div>

            <div className="tab-content">
                {selectedTab === "open" ? (
                    <AuctionsProfileOpen checkLoader={checkLoader} setCheckLoader={setCheckLoader} />
                ) : (
                    <AuctionsProfileClose
                    />
                )}
            </div>
        </>
    );
};

export default ProfileAuction;
